// extracted by mini-css-extract-plugin
export default {"icon":"SearchInput_icon__hW1Ye","value":"SearchInput_value__LqKVa","input":"SearchInput_input__BhHhd"};